// extracted by mini-css-extract-plugin
export default {"locationPersonnelSection":"styles_locationPersonnelSection__JWHxi","tagDetails":"styles_tagDetails__RAxwi","personnelOnTheAreaHeader":"styles_personnelOnTheAreaHeader__ZM1hJ"};